import $ from 'jquery';
import { getState } from '~src/state';

export const displayAnimationToolbars = () => {
  if (getState('pendingAnimation')) {
    $('#nav-default').hide();
    $('#nav-video').show();
  } else {
    $('#nav-default').show();
    $('#nav-video').hide();
  }
};
